export const ACTION_TYPES = {
	QUEUE_CLEAR_DATA: 'QUEUE_CLEAR_DATA',
	QUEUE_HEADER_SORT: 'QUEUE_SORT_BY_HEADER',
	QUEUE_INIT: 'QUEUE_INIT',
	QUEUE_LOADING: 'QUEUE_SET_LOADING',
	QUEUE_ROWS: 'QUEUE_SET_ROWS',
	QUEUE_ROWS_INDEX: 'QUEUE_INDEX_ROWS',
	QUEUE_ROW_TOGGLE: 'QUEUE_ROW_TOGGLE',
	QUEUE_ROWS_TOGGLE: 'QUEUE_TOGGLE_ROWS',
	QUEUE_FILTER_ROWS: 'QUEUE_FILTER_ROWS',
};

export const ACTION_FILTER_TYPES = {
	INVALID_INCLUDE: 'INVALID_INCLUDE',
	INVALID_EXCLUDE: 'INVALID_EXCLUDE',
	VALID_INCLUDE: 'VALID_INCLUDE',
	VALID_EXCLUDE: 'VALID_EXCLUDE',
	QUEUE_FILTER_PENDING: 'QUEUE_FILTER_PENDING',
	QUEUE_FILTER_APPLICATION: 'QUEUE_FILTER_APPLICATION',
	QUEUE_FILTER_UNASSIGNED: 'QUEUE_FILTER_UNASSIGNED',
};
